import * as React from "react"
import { AgeRanges, HowOldAreYouQuery, MedicinesRquiredQuery, HadSurgeryQuery, InsurancePaymentQuery, InsurancePayment } from '../FormQueries'
import { useState } from "react"
import { IContact } from "../../../api"
import { connect } from "react-redux"
import { updateContactForm } from "../../../actions"
import useContactFormClasses from "../contactFormClasses"

export interface Props {
    onSubmit: (state: HealthInsuranceResult)=>void
    updateContactForm: (contact: IContact) => void
}

export interface HealthInsuranceResult{
    medicinesRequired?: boolean,
    hadSurgery?: boolean,
    ageRange?: AgeRanges,
    insurancePayment?: InsurancePayment,
}

const HealthInsuranceForm = (props: Props) => {
    const [paymentQuery, setPaymentQuery] = useState(false);
    const [ageRange, setAgeRange] = useState(undefined);
    const [medicinesRequired, setMedicinesRequired] = useState(undefined);
    const [hadSurgery, setHadSurgery] = useState(undefined);
    const [insurancePayment, setInsurancePayment] = useState(undefined);

    const finished: boolean = ((ageRange !== undefined) && (hadSurgery !== undefined) && (medicinesRequired !== undefined));

    const onSubmit = () => {
        props.updateContactForm({ageRange, hadSurgery, medicinesRequired, insurancePayment } as IContact);
        props.onSubmit({ageRange, hadSurgery, medicinesRequired, insurancePayment})
    }

    const classes = useContactFormClasses()
    return (
        <div>
            <h1>ביטוח בריאות</h1>
            {(!paymentQuery) ?
            <div>
                <HowOldAreYouQuery onAnswer={(result: any) => {setAgeRange(result)}}/>
                <MedicinesRquiredQuery onAnswer={(result: any) => {setMedicinesRequired(result)}}/>
                <HadSurgeryQuery onAnswer={(result: any) => {setHadSurgery(result)}}/>
                {(finished) ?
                    <button className={classes.buttons.regular}  onClick={() => setPaymentQuery(true)}>המשך</button>:
                    <button className={classes.buttons.disabled}>המשך</button>}
            </div>:
            <div>
                <InsurancePaymentQuery insurance={'health_insurance'}
                    onAnswer={ (sellection: any) => { setInsurancePayment(sellection) }}/>
                {(insurancePayment !== undefined) ?
                    <button className={classes.buttons.regular} onClick={onSubmit}>המשך</button>:
                    <button className={classes.buttons.disabled}>המשך</button>}
            </div>
            }
        </div>
    )
}

export default connect(undefined, { updateContactForm })(HealthInsuranceForm)
